<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flow: [
            {
              name: '扫通道二维码自助进出场',
              desc: [
                '1、无牌车进场',
                {
                  preData: "车辆到达进口，用户在进口扫第三方系统的二维码，第三方系统取到用户的ID及通道ID后，通过接入",
                  link:  "扫通道二维码自助进出场",
                  url: "scanChannelCodeInOut",
                  endData: " 获取进场随机码并保存，"
                },
                '2、离场：',
                [
                  {
                    preData: "车辆到达出口，出口闸机提示随机码，用户扫离场通道二维码，第三方取得用户的ID及通道ID后，通过接入",
                    link:  "扫通道二维码自助进出场",
                    url: "scanChannelCodeInOut",
                    endData: " 获取随机码或车牌或者parkingCode，"
                  },
                  {
                    preData: "然后调起 ",
                    link:  "查费",
                    url: "getParkFee",
                    endData: " 接口获取该车辆的费用，在扣费成功后"
                  },
                  {
                    preData: "通过接入接口 ",
                    link:  "缴费",
                    url: "payParkFee",
                    endData: " 向停车场同步账单，停车场接收到账单且金额正确，道闸开启，车辆离场。"
                  },
                ]

              ],
              url: '/static/img/scanChannelCodeInOut.svg'
            },
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/scanChannelCodeInOutFlow.vue